import { DTypeForm } from '@grupo-constant/next-dtype/form';
import { DType, JsonReply, Partaker, SelectOption } from '@grupo-constant/next-dtype/types';
import { LocaleString } from '../translate/localeString.model';

export const TASK_TYPE_URI = 'dtype://com.cloudcodice.thirdparty.grupoconstant.nexttasktype.NextTaskType';
export const TASK_TYPE_FORM_URI = 'dtype://com.cloudcodice.thirdparty.grupoconstant.nexttasktype.form.NextTaskTypeForm';
export const TASK_TYPE_GOAL_URI = 'dtype://com.cloudcodice.thirdparty.grupoconstant.nexttasktype.goal.NextTaskTypeGoal';

export interface NextTaskType {
    taskTypeId?: string;
    ownerId?: string;
    belongsTo?: string;
    belongsToDN?: string;
    uri: string;
    name?: string;
    from?: string;
    userId?: string;
    datatypeUri?: string;
    payload?: any;
    typology?: TaskTypeTypology;
    consumesTime?: boolean;
    noticeUri?: string;
    taskTypeToStart?: string[];
    allowEndDate?: boolean;
    requiresPlanningStartTime?: boolean;
    requiresPlanningEndTime?: boolean;
    workDayTypeUri?: string;
    splitTimeOption?: boolean;
    howCanBeCreated?: 'USER' | 'BO' | 'BOTH';
    startMode?: 'ANY' | 'SUP';
    checkInMode?: 'GEOPOSITION' | 'SIMPLE';
    checkOutMode?: 'GEOPOSITION' | 'SIMPLE';
    distanceMaxToLocation?: number;
    requiresSpecificLocation?: boolean;
    locationMaster?: string;
    taskSending?: 'DONOTSEND' | 'AUTO';
    sendTasksAutomaticallyMinutesBeforeStart?: number;
    sendSMSAutomaticallyMinutesBeforeStart?: number;
    sendAlertIfNotStarted?: number;
    sendAlertIfNotClosed?: number;
    taskCanBeDelayedInStart?: boolean;
    taskCanBeDelayedInEnd?: boolean;
    allowStartTaskBeforeTime?: number;
    allowEndTaskBeforeTime?: number;
    goalAutoAssignment?: boolean;
    goalAutoAssignmentDistributeHours?: boolean;
    minutesToAdvanceSending?: number;
    minutesForFinishAutomaticallyOverdueTask?: number;
    minutesElapsedForTaskOverdueOnStart?: number;
    notifyTaskOverdueOnStart?: boolean;
    minutesElapsedForTaskOverdueOnFinish?: number;
    notifyTaskOverdueOnFinish?: boolean;
    minutesToAdvanceStart?: number;
    minutesToAdvanceFinish?: number;
    minutesToEditForms?: number;
    forms: NextTaskTypeForm[];
    goals: NextTaskTypeGoal[];
    dtype: DType;

    // Only for use on the interface
    sameLocator?: boolean;
    belongsToCaption?: string;
}

export interface NextTaskTypeForm {
    caption?: LocaleString;
    replyForm?: NextTaskTypeFormReplyTime;
    canEdit?: boolean;
    formUri?: string;
    formRelease?: number;
    minOccurs?: number;
    maxOccurs?: number;
    form?: DTypeForm;
    deprecated?: boolean;
    visiblePlanningAreaId?: string[];
    visibleWorkDayTypeId?: string[];
}

export enum NextTaskTypeFormReplyTime {
    beforeCheckIn = 'BEFORE_CHECK_IN',
    afterCheckIn = 'AFTER_CHECK_IN',
    beforePaused = 'BEFORE_PAUSED',
    afterPaused = 'AFTER_PAUSED',
    beforeRestart = 'BEFORE_RESTART',
    afterRestart = 'AFTER_RESTART',
    beforeCheckOut = 'BEFORE_CHECK_OUT',
    afterCheckOut = 'AFTER_CHECK_OUT'
}

export interface NextTaskTypeGoal {
    calculated?: boolean;
    caption?: LocaleString;
    deliveryMode?: NextTaskTypeGoalDeliveryMode;
    description?: LocaleString;
    form?: DTypeForm;
    fromMaster?: boolean;
    masterUri?: string;
    name?: string;
    overallContribution?: number;
    toOverallPercentage?: boolean;
    unitOfMeasurement?: LocaleString;
    from?: string;
    to?: string;
    order?: number;
}

export interface NextTaskTypeGoalResume {
    name?: string;
    from?: string;
    to?: string;
}

export enum NextTaskTypeGoalDeliveryMode {
    units = 'UNITS',
    percent = 'PERCENT'
}

export interface RetrieveNextTaskTypeListReply extends JsonReply {
    nextTaskType?: NextTaskType[];
    partaker?: Partaker;
    size?: number;
}

export interface RetrieveNextTaskTypeCollectionDN extends JsonReply {
    collection?: NextTaskTypeDN;
    partaker?: Partaker;
}

export interface NextTaskTypeDN {
    [locator: string]: {
        [uri: string]: NextTaskType;
    };
}

export interface RetrieveNextTaskTypeReply extends JsonReply {
    nextTaskType?: NextTaskType;
    partaker?: Partaker;
}

export interface FlushNextTaskTypeReply extends JsonReply {
    nextTaskType?: NextTaskType;
}

export interface RetrieveNewTaskTypeInstaceBody {
    typology: TaskTypeTypology;
}

export interface RetrieveNewTaskTypeInstanceReply {
    taskType: NextTaskType;
}

export interface RetrieveCompatibleNextTaskTypeReply extends JsonReply {
    taskTypeOptions?: SelectOption[];
}

export enum TaskTypeTypology {
    withTime = 'WITH_TIME',
    withoutTime = 'WITHOUT_TIME',
    taskAssigment = 'TASK_ASSIGNMENT',
    workshift = 'WORKSHIFT'
}
